module.exports = __webpack_public_path__ + "assets/img/37f09c7d743ea15475332a441eee947f.svg";